import { observer, inject } from 'mobx-react';
import React from 'react';
import closeIconSrc from 'common/assets/icons/common/signs/white-close-sign.svg';
import { appService } from 'common/services/app.service';
import { StackModal } from 'Components/StackModal';
import { S } from './style';

const RawCTAModal = ({
  ModalStore: { hideModal },
  modalID,
  icon,
  iconContent,
  circleColor,
  headingColor,
  onClose = () => {},
  heading,
  children,
  button = (
    <S.ActionButton onClick={appService.openRealAccount} type="accent">
      Open real account
    </S.ActionButton>
  ),
}) => {
  const onCloseClick = () => {
    hideModal(modalID);
    onClose();
  };
  return (
    <StackModal modalID={modalID}>
      <S.Backdrop>
        <S.CloseIcon src={closeIconSrc} onClick={onCloseClick} />
        <S.Container>
          <S.Circle bgColor={circleColor}>
            {iconContent || <S.CircleIcon src={icon} />}
          </S.Circle>
          {heading && (
            <S.Heading headingColor={headingColor}>{heading}</S.Heading>
          )}
          {children}
        </S.Container>
        {button}
      </S.Backdrop>
    </StackModal>
  );
};

export const DefaultCTAModal = inject('ModalStore')(observer(RawCTAModal));
